export interface IIncomingDocumentSummary {
  name: string
  incomingDate: Date
}

export class IncomingDocumentSummary implements IIncomingDocumentSummary {
  public name: string
  public incomingDate: Date
}
